import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL } from 'constants/config';

export default reduxApi({

  updateDonVaTrinh: {
    url: `${API_URL}/dons/luuDonVaTrinh/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },

  getThoiHanXuLyMacDinh: {
    url: `${API_URL}/dons/ngayMacDinhThoiHanXuLyDon`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },

  getThoiHanXuLy: {
    url: `${API_URL}/thoiHans?loaiThoiHan=THOIHAN_XULYDON&page=0&size=1000&sort=soNgay,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getNguonDon: {
    url: `${API_URL}/nguonTiepNhanDons?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getDonDetail: {
    url: `${API_URL}/dons/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getDonCuDetail: {
    url: `${API_URL}/donCus/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getphanLoaiNguoiDungDon: {
    url: `${API_URL}/phanLoaiNguoiDungDons`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  deleteDonCongDan: {
    url: `${API_URL}/donCongDans/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  deleteTaiLieuBangChung: {
    url: `${API_URL}/taiLieuBangChungs/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  updateDon: {
    url: `${API_URL}/dons/:id`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'PATCH',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  deleteDon: {
    url: `${API_URL}/dons/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  getDetailReception: {
    url: `${API_URL}/soTiepCongDans/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuongBKT: {
    url: `${API_URL}/loaiDoiTuongBiKhieuTos`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getHuongXuLyTCD: {
    url: `${API_URL}/huongXuLyTCDs`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTiepCongDan: {
    url: `${API_URL}/soTiepCongDans?loaiTiepCongDan=THUONG_XUYEN&page=:page&size=:size&sort=ngayTao,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTiepCongDanDinhKy: {
    url: `${API_URL}/soTiepCongDans?loaiTiepCongDan=DINH_KY&page=:page&size=:size&sort=ngayTao,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getListLanhDao: {
    url: `${API_URL}/lanhDaoTiepCongDans?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getTiepCongDanDotXuat: {
    url: `${API_URL}/soTiepCongDans?loaiTiepCongDan=DOT_XUAT&page=:page&size=:size&sort=ngayTao,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  searchTiepCongDan: {
    url: `${API_URL}/soTiepCongDans?tuKhoa=:tuKhoa&loaiTiepCongDan=THUONG_XUYEN&page=:page&size=:size&sort=ngayTao,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  superSearchTiepCongDan: {
    url: `${API_URL}/soTiepCongDans?loaiTiepCongDan=THUONG_XUYEN&tuKhoa=:tuKhoa&phanLoaiDon=:phanLoaiDon&huongXuLy=:huongXuly&page=:page&size=:size&sort=ngayTao,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  searchTiepCongDanDinhKy: {
    url: `${API_URL}/soTiepCongDans?tuKhoa=:tuKhoa&loaiTiepCongDan=DINH_KY&page=:page&size=:size&sort=ngayTao,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  superSearchTiepCongDanDinhKy: {
    url: `${API_URL}/soTiepCongDans?loaiTiepCongDan=DINH_KY&tuKhoa=:tuKhoa&phanLoaiDon=:phanLoaiDon&huongXuLy=:huongXuly&page=:page&size=:size&sort=ngayTao,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  searchTiepCongDanDotXuat: {
    url: `${API_URL}/soTiepCongDans?tuKhoa=:tuKhoa&loaiTiepCongDan=DOT_XUAT&page=:page&size=:size&sort=ngayTao,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  superSearchTiepCongDanDotXuat: {
    url: `${API_URL}/soTiepCongDans?loaiTiepCongDan=DOT_XUAT&tuKhoa=:tuKhoa&phanLoaiDon=:phanLoaiDon&huongXuLy=:huongXuly&page=:page&size=:size&sort=ngayTao,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDungDon: {
    url: `${API_URL}/phanLoaiNguoiDungDons?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getQuocTich: {
    url: `${API_URL}/quocTichs?page=0&size=1000&sort=ten,asc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getDanToc: {
    url: `${API_URL}/danTocs?page=0&size=1000&sort=ten,asc&cha=:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getToDanPho: {
    url: `${API_URL}/toDanPhos?page=0&size=1000&sort=ten,desc&donViHanhChinh=:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCapPhuongXa: {
    url: `${API_URL}/donViHanhChinhs/capPhuongXa?page=0page&size=1000&sort=ten,desc&cha=:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getListCapPhuongXa: {
    url: `${API_URL}/donViHanhChinhs?page=0page&size=1000&sort=ten,desc&cha=:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCapQuanHuyen: {
    url: `${API_URL}/donViHanhChinhs/capQuanHuyen?page=0&size=1000&sort=ten,desc&cha=:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCapTinhThanhPho: {
    url: `${API_URL}/donViHanhChinhs/capTinhThanhPho?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDonThu: {
    url: `${API_URL}/loaiDonThus?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getHuongXuLy: {
    url: `${API_URL}/huongXuLyTCDs?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuong: {
    url: `${API_URL}/loaiDoiTuongs?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLinhVucDonThu: {
    url: `${API_URL}/linhVucDonThus?page=0&size=1000&sort=ten,desc&cha=:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getNoiCap: {
    url: `${API_URL}/coQuanQuanLys/noiCapCMNDs?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getThamQuyen: {
    url: `${API_URL}/thamQuyenGiaiQuyets?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getHinhThucGiaiQuyet: {
    url: `${API_URL}/hinhThucDaGiaiQuyet?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getLoaiDoiTuongBiKhieuTo: {
    url: `${API_URL}/loaiDoiTuongBiKhieuTos?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  searchCongDan: {
    url: `${API_URL}/congDanBySuggests?page=:page&size=:size&tuKhoa=:name&soCMNND=:cmnd&diaChi=:diaChi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  postDonVaTrinh: {
    url: `${API_URL}/dons/taoDonMoiVaTrinhDon`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },

  postDon: {
    url: `${API_URL}/dons`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  postDonCongDan: {
    url: `${API_URL}/donCongDans`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postCongDan: {
    url: `${API_URL}/congDans`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postTaiLieuBangChung: {
    url: `${API_URL}/taiLieuBangChungs`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateTaiLieuBangChung: {
    url: `${API_URL}/taiLieuBangChungs/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  postSoTiepCongDan: {
    url: `${API_URL}/soTiepCongDans`,
    options: (url, params, getState) => {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      return {
        method: 'POST',
        data: {
          ...params,
          donViId: userInfo.donViId,
          congChucId: userInfo.id
        }
      };
    }
  },
  updateSoTiepCongDan: {
    url: `${API_URL}/soTiepCongDan/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getCongchucOfUser: {
    url: `${API_URL}/congChucs/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getSoTiepCongDanDetail: {
    url: `${API_URL}/soTiepCongDans/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  deleteTiepCongDan: {
    url: `${API_URL}/soTiepCongDans/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'DELETE'
      };
    }
  },
  getCapCoQuan: {
    url: `${API_URL}/capCoQuanQuanLys?page=0&size=1000&sort=ten,desc`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getCoQuan: {
    url: `${API_URL}/coQuanQuanLys?page=0&size=1000&sort=ten,desc&capCoQuanQuanLy=:capCQID`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLichSuDon: {
    url: `${API_URL}/dons/:id/lichSus?page=0&size=1000`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getLichSuKeHoach: {
    url: `${API_URL}/kehoachthanhtras/:id/lichSus`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getTrangThaiDon: {
    url: `${API_URL}/dons/:id/trangThaiDon`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCoQuanDetail: {
    url: `${API_URL}/coQuanQuanLys/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getIdThanhPhoDN: {
    url: `${API_URL}/thamSos?tuKhoa=CQQL_UBNDTP_DA_NANG`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  }
}).use('fetch', customFetch);



// WEBPACK FOOTER //
// ./src/api/letter.js